export default function (context, agreement) {
  let ag = context.state.list.filter(i => {
    return i.code === agreement.code
  });
  let form = context.rootState.finances.pay.form;
  let c_request = agreement.currency;
  let c_agreement = agreement.AGCurrency;
  let c_form = form.CurrencyId;
  let national1 = context.rootGetters['dictionary/currency/getById'](c_form).IsNational;
  let national2 = context.rootGetters['dictionary/currency/getById'](c_request).IsNational;
  if (c_request !== c_form) {
    let val = agreement.requests[0] ? agreement.requests[0].course : 1;
    if (form.ContragentType === 3) {
      if (c_agreement === c_form) {
        context.dispatch('change_course', {agreement, value: val});
        return;
      }
    }
    if (form.ContragentType === 1 || form.ContragentType === 2) {
      if (c_agreement === c_request && national2) {
        context.dispatch('change_course', {agreement, value: val});
        return;
      }
    }
    context.dispatch(
      'finances/pay/rates/get',
      ({
        date: agreement.date,
        c1: c_request,
        c2: c_form,
        callback: (rate) => {
          context.dispatch('change_course', {agreement, value: rate.course});
        }
      }),
      {root: true}
    );
  }
}